import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'verify_email' */ './VerifyEmail'),
);
